import { MutationTree } from 'vuex';
import { ILieferantEinstellungenState } from './state';
import { BenutzerInfoSearchResultApiDto } from '@/api-schema';

export const MAPBENUTZERDATA = 'mapBenutzerData';
export const LOADING_BENUTZER = 'setBenutzerLoading';
export const MAPBENUTZERDETAILS = 'mapBenutzerDetails';

export const MAPLIEFERANTBENUTZERDATA = 'mapLieferantBenutzerData';

export const mutations: MutationTree<ILieferantEinstellungenState> = {
    [MAPBENUTZERDATA](state, benutzerInfoSearchResultApiDto: BenutzerInfoSearchResultApiDto) {
        state.benutzerInfoSearchResultApiDto = benutzerInfoSearchResultApiDto;
    },
    [LOADING_BENUTZER](state, loading) {
        state.benutzerLoading = loading;
    },
    [MAPBENUTZERDETAILS](state, data) {
        state.benutzerDetails = data;
    },
    [MAPLIEFERANTBENUTZERDATA](state, data) {
        state.lieferantBenutzerData = data;
    }
};
